/**
 * Blog post catalog. Each post has a slug and short metadata used by the /blog hub.
 * Full article content lives in BLOG_CONTENT (keyed by slug) below.
 */

export const BLOG_POSTS = [
  {
    slug: "que-es-el-glutation-antioxidante-maestro",
    category: "Salud celular",
    title: "¿Qué es el glutatión y por qué es el antioxidante maestro?",
    excerpt: "Una guía clara y científica del antioxidante que tu cuerpo produce, cómo funciona y por qué tus células lo necesitan.",
    minutes: 8,
    date: "2026-05-30",
  },
  {
    slug: "immunocal-vs-proteina-whey",
    category: "Comparativas",
    title: "Immunocal vs proteína whey común: 7 diferencias clave",
    excerpt: "Por qué una proteína aislada bioactiva no es lo mismo que cualquier whey de gimnasio.",
    minutes: 6,
    date: "2026-05-30",
  },
  {
    slug: "estres-oxidativo-explicado",
    category: "Medicina funcional",
    title: "Estrés oxidativo: cómo daña tu cuerpo y cómo combatirlo",
    excerpt: "El proceso silencioso detrás del envejecimiento y muchas enfermedades crónicas.",
    minutes: 7,
    date: "2026-05-30",
  },
  {
    slug: "immunocal-precio-mexico-2026",
    category: "Guía de compra",
    title: "Immunocal precio México 2026: presentaciones y dónde comprar",
    excerpt: "Comparativa de presentaciones, precio público vs distribuidor y cómo acceder al Kit de Inicio con descuento.",
    minutes: 5,
    date: "2026-05-30",
  },
  {
    slug: "biohacking-para-principiantes",
    category: "Biohacking",
    title: "Biohacking para principiantes: 10 hábitos para optimizar tu cuerpo",
    excerpt: "Una introducción accesible al arte de optimizar tu biología con ciencia y hábitos sostenibles.",
    minutes: 9,
    date: "2026-05-30",
  },
  {
    slug: "como-estar-preparado-cuando-la-enfermedad-llega",
    category: "Medicina funcional",
    title: "Cómo estar preparado cuando la enfermedad llega: la mirada de la medicina funcional",
    excerpt: "Las enfermedades no aparecen de un día para otro. Esta es la estrategia para que tu cuerpo esté listo cuando el reto llegue.",
    minutes: 10,
    date: "2026-05-30",
  },
  {
    slug: "immunocal-platinum-beneficios",
    category: "Producto",
    title: "Immunocal Platinum: por qué es la fórmula para mayores de 40",
    excerpt: "Citrato de potasio y magnesio, regulación del pH y salud ósea: el upgrade pensado en adultos +40.",
    minutes: 6,
    date: "2026-05-30",
  },
  {
    slug: "immunocal-sport-para-atletas",
    category: "Producto",
    title: "Immunocal Sport: la proteína de los atletas que cuidan su recuperación",
    excerpt: "Electrolitos, creatina y proteína bioactiva. La fórmula diseñada para entrenamiento intenso y recuperación.",
    minutes: 6,
    date: "2026-05-30",
  },
  {
    slug: "xtriva-energia-natural",
    category: "Producto",
    title: "XTRIVA: la alternativa natural a las bebidas energéticas",
    excerpt: "Cafeína natural, adaptógenos y vitaminas: energía sostenida sin el bajón.",
    minutes: 5,
    date: "2026-05-30",
  },
  {
    slug: "omega-gen-v-5-en-1",
    category: "Producto",
    title: "Omega Gen V: el 5 en 1 que tu cerebro y corazón necesitan",
    excerpt: "Omega-3 EPA/DHA, vitamina D, vitamina K, CoQ10 y resveratrol en una sola cápsula.",
    minutes: 6,
    date: "2026-05-30",
  },
  {
    slug: "menopausia-y-glutation",
    category: "Mujer +40",
    title: "Menopausia y glutatión: cómo el antioxidante maestro alivia los síntomas",
    excerpt: "La conexión entre el estrógeno, el glutatión y por qué muchos síntomas de la menopausia tienen una raíz antioxidante.",
    minutes: 8,
    date: "2026-06-04",
  },
  {
    slug: "como-tomar-immunocal-correctamente",
    category: "Producto",
    title: "Cómo tomar Immunocal correctamente: 7 errores comunes y cómo evitarlos",
    excerpt: "Si vas a invertir en Immunocal, vale la pena hacer cada toma de manera que dé el máximo retorno biológico.",
    minutes: 7,
    date: "2026-06-04",
  },
  {
    slug: "niebla-mental-causas-y-solucion",
    category: "Salud cerebral",
    title: "Niebla mental: por qué se nubla tu mente y cómo recuperar claridad",
    excerpt: "La niebla mental casi nunca es enfermedad cerebral. Es un síntoma de seis causas concretas que se pueden resolver.",
    minutes: 9,
    date: "2026-06-04",
  },
  {
    slug: "inflamacion-silenciosa-fatiga-peso-dolor",
    category: "Medicina funcional",
    title: "Inflamación silenciosa: la causa oculta de tu fatiga, peso y dolor",
    excerpt: "Una inflamación crónica de bajo grado puede estar detrás del cansancio, peso que no baja y dolor sin causa clara.",
    minutes: 9,
    date: "2026-06-04",
  },
  {
    slug: "diabetes-tipo-2-y-glutation",
    category: "Padecimientos",
    title: "Diabetes tipo 2 y glutatión: cómo proteger tus tejidos del daño silencioso",
    excerpt: "La diabetes destruye tu sistema antioxidante. Conoce cómo el glutatión protege ojos, riñones, nervios y corazón.",
    minutes: 8,
    date: "2026-06-11",
  },
  {
    slug: "hipertension-y-antioxidantes",
    category: "Padecimientos",
    title: "Hipertensión y antioxidantes: el papel del glutatión en tus arterias",
    excerpt: "La hipertensión esencial se conecta con estrés oxidativo del endotelio. Qué puedes hacer además del medicamento.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "tiroides-hipotiroidismo-hashimoto",
    category: "Padecimientos",
    title: "Tiroides y Hashimoto: glutatión, selenio y la conexión autoinmune",
    excerpt: "La tiroiditis autoinmune es estrés oxidativo. Cómo apoyar tu tiroides sin sustituir tu levotiroxina.",
    minutes: 8,
    date: "2026-06-11",
  },
  {
    slug: "gastritis-cronica-y-glutation",
    category: "Padecimientos",
    title: "Gastritis crónica: el rol del glutatión en la mucosa gástrica",
    excerpt: "Años de omeprazol no atacan la raíz. La mucosa inflamada necesita glutatión para repararse.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "colitis-disbiosis-intestinal",
    category: "Padecimientos",
    title: "Colitis y disbiosis intestinal: protocolo 5R de medicina funcional",
    excerpt: "Detrás de la colitis siempre hay inflamación y desequilibrio de microbiota. El protocolo 5R y el papel del glutatión.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "higado-graso-no-alcoholico-nafld",
    category: "Padecimientos",
    title: "Hígado graso: la enfermedad silenciosa más común en México (y cómo revertirla)",
    excerpt: "1 de cada 3 mexicanos lo tiene. El hígado graso es reversible si actúas a tiempo. Protocolo completo.",
    minutes: 8,
    date: "2026-06-11",
  },
  {
    slug: "sindrome-metabolico-y-obesidad",
    category: "Padecimientos",
    title: "Síndrome metabólico y obesidad: estrategia integral 90 días",
    excerpt: "1 de cada 3 adultos mexicanos lo cumple. Es la antesala silenciosa de diabetes, infarto e ictus.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "artritis-dolor-articular-cronico",
    category: "Padecimientos",
    title: "Artritis y dolor articular: protocolo antinflamatorio integral",
    excerpt: "Toda artritis tiene un componente inflamatorio. Cómo apoyarte con glutatión, omega-3 y hábitos diarios.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "fibromialgia-fatiga-cronica",
    category: "Padecimientos",
    title: "Fibromialgia y fatiga crónica: el problema mitocondrial detrás del agotamiento",
    excerpt: "No es flojera ni pereza: hay disfunción mitocondrial. Cómo apoyar la batería celular con paciencia.",
    minutes: 7,
    date: "2026-06-11",
  },
  {
    slug: "ansiedad-depresion-eje-intestino-cerebro",
    category: "Padecimientos",
    title: "Ansiedad y depresión: el eje intestino-cerebro que la psiquiatría empieza a reconocer",
    excerpt: "El 90% de la serotonina se produce en el intestino. La salud mental tiene una raíz intestinal e inflamatoria.",
    minutes: 8,
    date: "2026-06-11",
  },
  {
    slug: "frutos-rojos-salud-de-la-mujer",
    category: "Mujer +40",
    title: "Frutos rojos y salud de la mujer: el alimento más estudiado para vitalidad femenina",
    excerpt: "Antocianinas, fitoestrógenos suaves, salud cardiovascular y prevención cognitiva. Por qué una taza al día cambia tu salud después de los 35.",
    minutes: 6,
    date: "2026-06-12",
  },
  {
    slug: "optimizer-performance-3-cafeinas-deportistas",
    category: "Producto",
    title: "Optimizer Performance: las 3 cafeínas inteligentes para deportistas",
    excerpt: "Guaraná + cafeína anhidra + té verde con L-Teanina. Energía sostenida 4-6 horas, sin picos ni crash. Cómo funciona y cómo tomarlo.",
    minutes: 6,
    date: "2026-06-12",
  },
  {
    slug: "knutric-diabetes-control-glucemico",
    category: "Padecimientos",
    title: "Knutric y diabetes: control glucémico natural con fibra, nopal y cromo",
    excerpt: "Cómo Knutric apoya a personas con diabetes tipo 2: reducción de picos posprandiales, mejor sensibilidad a la insulina y protocolo Immunotec completo.",
    minutes: 7,
    date: "2026-06-12",
  },
];

// Full content for each post (slug → JSX render function returning React nodes)
// Kept as a separate map so the hub stays light.
